"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _core = require("core.ui-module_site-components");
var _SecurityContextHolder = require("../api/SecurityContextHolder");
var _ApplicationContext = require("../api/ApplicationContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable no-restricted-syntax */ /* eslint-disable guard-for-in */
class TimeoutModal extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "keepActiveSession", () => {
      this.setState({
        showModal: false
      });
      this.clearLogoutTimeout();
      this.resetWarnTimeout();
    });
    _defineProperty(this, "manualLogout", () => {
      const {
        history,
        logoutPath
      } = this.props;
      this.clearLogoutTimeout();
      this.clearWarnTimeout();
      this.setState({
        showModal: false
      });
      setTimeout(() => history.push(logoutPath), 0);
    });
    _defineProperty(this, "logout", () => {
      const {
        history,
        logoutPath
      } = this.props;
      this.clearLogoutTimeout();
      this.clearWarnTimeout();
      this.setState({
        showModal: false
      });
      setTimeout(() => history.push(logoutPath), 0);
    });
    this.state = {
      showModal: false,
      isAuthenticated: false
    };
    this.resetWarnTimeout = this.resetWarnTimeout.bind(this);
    this.clearWarnTimeout = this.clearWarnTimeout.bind(this);
    this.clearLogoutTimeout = this.clearLogoutTimeout.bind(this);
    this.setWarnTimeout = this.setWarnTimeout.bind(this);
    this.warn = this.warn.bind(this);
    this.keepActiveSession = this.keepActiveSession.bind(this);
    this.logout = this.logout.bind(this);
    this.manualLogout = this.manualLogout.bind(this);
  }
  setWarnTimeout() {
    let {
      timeout
    } = this.props;
    timeout = timeout <= 1 ? 2 : timeout;
    this.warnTimeout = setTimeout(this.warn, (timeout - 1) * 60 * 1000);
  }
  clearWarnTimeout() {
    if (this.warnTimeout) clearTimeout(this.warnTimeout);
  }
  clearLogoutTimeout() {
    if (this.logoutTimeout) clearTimeout(this.logoutTimeout);
  }
  componentDidMount() {
    const {
      history
    } = this.props;
    const {
      isAuthenticated
    } = this.state;
    this.events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress'];
    for (const i in this.events) {
      window.addEventListener(this.events[i], this.resetWarnTimeout);
    }
    this.unlisten = history.listen(() => {
      if (isAuthenticated !== _SecurityContextHolder.SecurityContextHolder.isAuthenticated()) {
        this.setState({
          isAuthenticated: _SecurityContextHolder.SecurityContextHolder.isAuthenticated()
        });
      }
    });
    this.setWarnTimeout();
  }
  componentWillUnmount() {
    this.unlisten();
    this.clearWarnTimeout();
    this.clearLogoutTimeout();
    for (const i in this.events) {
      window.removeEventListener(this.events[i], this.resetWarnTimeout);
    }
  }
  warn() {
    if (_SecurityContextHolder.SecurityContextHolder.isAuthenticated()) {
      this.setState({
        showModal: true
      });
      this.logoutTimeout = setTimeout(this.logout, 60 * 1000);
    }
  }
  resetWarnTimeout() {
    this.clearWarnTimeout();
    this.setWarnTimeout();
  }
  render() {
    const {
      showModal
    } = this.state;
    let {
      timeout
    } = this.props;
    timeout = timeout <= 1 ? 2 : timeout;
    return showModal && /*#__PURE__*/_react.default.createElement(_core.Modal, {
      header: "Your MissionSquare Retirement Session is about to expire",
      showCloseIcon: false,
      footer: /*#__PURE__*/_react.default.createElement("div", {
        className: "notificationPopup"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "columns"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "column is-6"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "submit",
        className: "button is-secondary is-pulled-left timeoutMotalStay",
        onClick: () => this.keepActiveSession()
      }, "Stay Logged In")), /*#__PURE__*/_react.default.createElement("div", {
        className: "column is-6"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "submit",
        className: "button is-primary is-pulled-right fixedButtonSize",
        onClick: () => this.manualLogout()
      }, "Logout"))))
    }, /*#__PURE__*/_react.default.createElement("span", null, "To protect the sensitivity of your financial data, sessions are automatically terminated after ", timeout, " minutes of inactivity."));
  }
}
var _default = exports.default = (0, _reactRouterDom.withRouter)(TimeoutModal);
TimeoutModal.propTypes = {
  logoutPath: _propTypes.default.string,
  timeout: _propTypes.default.number.isRequired,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired,
    listen: _propTypes.default.func.isRequired
  })
};
TimeoutModal.defaultProps = {
  logoutPath: _ApplicationContext.ApplicationContext.getLogoutPath(),
  timeout: _ApplicationContext.ApplicationContext.getSiteInactiveTimeout()
};
//# sourceMappingURL=TimeoutModal.js.map